import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumTranslateFormStyle: StyleRulesCallback = () => {
  return {
    root: {},
  };
};

export default enumTranslateFormStyle;
